var map = {
	"./featured-title.de-CH.json": 1115,
	"./featured-title.de-DE.json": 1116,
	"./featured-title.en-CA.json": 1117,
	"./featured-title.en-GB.json": 1118,
	"./featured-title.en-IN.json": 1119,
	"./featured-title.en-ME.json": 1120,
	"./featured-title.en-US.json": 1121,
	"./featured-title.es-EM.json": 1122,
	"./featured-title.es-ES.json": 1123,
	"./featured-title.fr-BE.json": 1124,
	"./featured-title.fr-CA.json": 1125,
	"./featured-title.fr-CH.json": 1126,
	"./featured-title.nl-BE.json": 1127,
	"./featured-title.nl-NL.json": 1128,
	"./featured-title.pl-PL.json": 1129,
	"./featured-title.pt-BR.json": 1130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1114;